const initialState = {
  user: {},
  token: "",
  phoneNumber: "",
  OTPState: "",
};

export default initialState;
